"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sortWeekdays = function (items) {
    var sortedByDay = [{}];
    items.forEach(function (item) {
        switch (item.label) {
            case 'Maandag':
                sortedByDay[0] = item;
                break;
            case 'Dinsdag':
                sortedByDay[1] = item;
                break;
            case 'Woensdag':
                sortedByDay[2] = item;
                break;
            case 'Donderdag':
                sortedByDay[3] = item;
                break;
            case 'Vrijdag':
                sortedByDay[4] = item;
                break;
            case 'Zaterdag':
                sortedByDay[5] = item;
                break;
            case 'Zondag':
                sortedByDay[6] = item;
                break;
            case '7 dagen per week':
                sortedByDay[7] = item;
                break;
            case 'diverse dagen':
                sortedByDay[8] = item;
                break;
            case 'Donderdsg':
                sortedByDay[9] = item;
                break;
            default:
                console.log("unsupported day value; " + item);
        }
    });
    return sortedByDay;
};
exports.default = sortWeekdays;
